<template>
  <v-container>
    <h1>Application Logs</h1>
    <hr />

    <LogsTable
      :loading="loading"
      :logs="logs"
      :totalLogs="totalLogs"
      @removeAll="removeAll"
      @page:changed="getNewPage"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import LogsTable from './LogsTable'

export default {
  name: 'Logs',
  components: {
    LogsTable,
  },
  data: () => ({
    loading: false,
    logs: [],
    totalLogs: 0,
  }),
  computed: {
    ...mapGetters('feathers', ['apiLogs']),
  },

  created () {
    this.getNewPage()
  },

  methods: {
    async getNewPage (page = 1, itemsPerPage = 10) {
      const query = {
        $limit: itemsPerPage,
        $skip: itemsPerPage * (page - 1),
        $sort: { createdAt: -1 },
      }

      this.loading = true

      try {
        const results = await this.apiLogs.find({ query })

        this.logs = results.data || []
        this.totalLogs = results.total || 0
      } catch (error) {
        this.addErrorAlert(`Error retrieving app logs: ${error.message}`)
      }

      this.loading = false
    },

    async removeAll () {
      this.loading = true

      try {
        await this.apiLogs.remove(null)

        this.logs = []
        this.totalLogs = 0

        this.addSuccessAlert('All application logs have been cleared out')
      } catch (error) {
        this.addErrorAlert(`Error removing logs: ${error.message}`)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
